import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';

const styles = () => ({
    sectionLabel: {
        fontSize: '1.5rem'
    }
});

/**
 * Renderiza o rótulo de uma seção da página
 * @param {Object} props Propriedades do componente
 * @param {Object} props.classes Classes CSS do componente
 * @param {String} props.classes.sectionLabel Estilo do componente
 * @param {String} props.label Rótulo a ser exibido no componente
 */
function LabelSecao({ classes, label }) {
    return (
        <Typography className={classes.sectionLabel}>{label}</Typography>
    );
}

LabelSecao.propTypes = {
    /** Classes CSS */
    classes: PropTypes.shape({
        /** Estilo do rótulo */
        sectionLabel: PropTypes.string
    }),
    /** Conteúdo do componente */
    label: PropTypes.string.isRequired
};

export default withStyles(styles)(LabelSecao);